// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-country-code {
  min-width: 11rem;
  margin-right: 1.2rem;
  max-width: 6.25rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/fields/PhoneNumberForm/CountryCode/index.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;AACF","sourcesContent":[".phone-country-code {\n  min-width: 11rem;\n  margin-right: 1.2rem;\n  max-width: 6.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
